import React from "react";
import { Link } from 'react-router-dom';

const BottomPanel = (props) => {
    return  (
	 	<div className="bottom-panel" style={{padding: '15px 55px'}}>
	        <div className="social-btn" style={{width:'auto'}}>
	            <a className="powered-by" href="https://garpix.com/ru/" target="_blank">
                Создание сайта
				</a>
	        </div>
	    </div>
    )
}

export default BottomPanel


// WEBPACK FOOTER //
// ./src/components/BottomPanelSecond.js